"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _api = _interopRequireDefault(require("./api"));

var _config = _interopRequireDefault(require("../../config"));

var tokenUtil = _interopRequireWildcard(require("../../token/utils/token"));

var _API_TOKEN_REFRESH_FA;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MODULE_NAME = 'sdk/api/services/authentication';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var API_TOKEN_REFRESH_FAIL = 'API_TOKEN_REFRESH_FAIL';
var API_HASH_REQUIRED = 'API_HASH_REQUIRED';
var SELECT_SUBSCRIBER = 'SELECT_SUBSCRIBER';
var NO_SUBSCRIBER = 'NO_SUBSCRIBER';
var CONF_ID_REQUIRED = 'CONF_ID_REQUIRED';
var INVALID_TOKEN = 'INVALID_TOKEN';
var MFA_REQUIRED = 'MFA_REQUIRED';
var LOGIN_FAIL = 'LOGIN_FAIL';
var NO_CONF = 'NO_CONF';
var NO_STORED_TOKEN = 'NO_STORED_TOKEN';

var processToken = function processToken(tokenStr) {
  logger.debug("".concat(MODULE_NAME, " - processToken res"), tokenStr);

  if (!tokenStr) {
    logger.debug("".concat(MODULE_NAME, " - processToken tokenStr null"), LOGIN_FAIL);
    return LOGIN_FAIL;
  }

  if (!tokenUtil.isValid(tokenStr)) {
    logger.debug("".concat(MODULE_NAME, " - processToken token.isValid reject"), INVALID_TOKEN);
    return INVALID_TOKEN;
  }

  var decodedToken = tokenUtil.decode(tokenStr);
  logger.debug("".concat(MODULE_NAME, " - processToken decodedToken"), decodedToken);
  tokenUtil.set(tokenStr); // mfa stuff happens after user & token are set because the session is in 'half authorized' state, pending mfa completion

  if (decodedToken.user_scope === 'mfa_required') {
    logger.debug("".concat(MODULE_NAME, " - processToken mfa_required reject"), MFA_REQUIRED);
    return {
      reason: MFA_REQUIRED,
      mfa_type: decodedToken.mfa_type,
      mfa_vendor: decodedToken.mfa_vendor
    };
  }

  return true;
};
/**
 *
 * 1) stretch and do some warm up cardio
 * 2) get the user's token from local storage, else 'NO_STORED_TOKEN'
 * 3) validate the token, else 'INVALID_TOKEN'
 * 4) use ns-api to refresh the token, else 'API_TOKEN_REFRESH_FAIL'
 * 5) save the refreshed token in local storage and start the refresh timer
 *
 * @returns {Promise}
 * @private
 */


var tokenLogin = function tokenLogin(apiHash) {
  logger.info("".concat(MODULE_NAME, " - tokenLogin called")); // eslint-disable-next-line consistent-return

  return new Promise(function (resolve, reject) {
    var userToken = tokenUtil.get();

    if (!userToken) {
      logger.debug("".concat(MODULE_NAME, " - tokenLogin reject"), NO_STORED_TOKEN);
      reject(NO_STORED_TOKEN);
      return false;
    }

    if (!tokenUtil.isValid(userToken)) {
      logger.debug("".concat(MODULE_NAME, " - tokenLogin reject"), INVALID_TOKEN);
      reject(INVALID_TOKEN);
      return false;
    }

    _api.default.refreshToken(userToken, apiHash).then(function (newToken) {
      logger.debug("".concat(MODULE_NAME, " - tokenLogin api.refreshToken newToken"), newToken);
      resolve(true);
      tokenUtil.set(newToken);
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - tokenLogin api.refreshToken err"), API_TOKEN_REFRESH_FAIL, err);
      reject(API_TOKEN_REFRESH_FAIL);
      return false;
    });
  });
};
/**
 *
 * @param {string} username
 * @param {string} password
 * @param {string|undefined} scope optional Application type Expects: 'netsapiens', 'webphone', 'video'
 * @param {string} apiHash base64 encoding of client id and secret
 *  Passing api_hash will attempt to login to the api directly
 * @param {string|undefined} authCode used for password recovery flow
 * @return {Promise} Promise returns true, 'NO_SDK_CONFIG', 'LOGIN_FAIL', 'API_HASH_REQUIRED', 'INVALID_TOKEN', 'MFA_REQUIRED'
 */


var authenticate = function authenticate(_ref) {
  var username = _ref.username,
      password = _ref.password,
      apiHash = _ref.apiHash,
      authCode = _ref.authCode,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'netsapiens' : _ref$scope;
  logger.info("".concat(MODULE_NAME, " - authenticate called"), {
    username: username,
    password: password,
    apiHash: apiHash,
    authCode: authCode,
    scope: scope
  });
  return new Promise(function (resolve, reject) {
    var _data;

    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    if (!apiHash) {
      logger.error("".concat(MODULE_NAME, " - authentication apiHash prop missing"));
      console.error('authentication apiHash prop missing');
      reject(API_HASH_REQUIRED);
    }

    var grantType = 'password';

    if (authCode) {
      grantType = 'authorization_code';
    }

    var _config$getConfigurat = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat.apiURL;

    (0, _axios.default)({
      method: 'post',
      withCredentials: true,
      url: "".concat(apiURL, "oauth2/netsapiensJs"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: (_data = {
        grant_type: grantType
      }, (0, _defineProperty2.default)(_data, authCode ? 'code' : null, authCode), (0, _defineProperty2.default)(_data, "username", username), (0, _defineProperty2.default)(_data, "password", password), (0, _defineProperty2.default)(_data, "scope", scope), _data)
    }).then(function (res) {
      var tokenResult = processToken(res.data.token);

      if (tokenResult === true) {
        resolve(true);
      } else {
        reject(tokenResult);
      }
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - authenticate err"), err);
      reject(err);
    });
  });
};
/**
 *
 * @param {string} idtoken
 * @param {string} vendor
 * @param username
 * @param {string} apiHash base64 encoding of client id and secret
 *  Passing api_hash will attempt to login to the api directly
 * @param scope
 * @return {Promise} Promise returns true, 'NO_SDK_CONFIG', 'LOGIN_FAIL', 'API_HASH_REQUIRED', 'INVALID_TOKEN'
 */


var ssoLogin = function ssoLogin(_ref2) {
  var idtoken = _ref2.idtoken,
      vendor = _ref2.vendor,
      username = _ref2.username,
      apiHash = _ref2.apiHash,
      _ref2$scope = _ref2.scope,
      scope = _ref2$scope === void 0 ? 'netsapiens' : _ref2$scope;
  logger.info("".concat(MODULE_NAME, " - ssoLogin called"), {
    idtoken: idtoken,
    vendor: vendor,
    username: username,
    apiHash: apiHash,
    scope: scope
  });
  return new Promise(function (resolve, reject) {
    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    if (!apiHash) {
      logger.error("".concat(MODULE_NAME, " - ssoLogin apiHash prop missing"));
      console.error('ssoLogin apiHash prop missing');
      reject(API_HASH_REQUIRED);
    }

    var _config$getConfigurat2 = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat2.apiURL;

    (0, _axios.default)({
      method: 'post',
      withCredentials: true,
      url: "".concat(apiURL, "oauth2/netsapiensJs"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: {
        grant_type: vendor,
        idtoken: idtoken,
        username: username,
        vendor: vendor,
        scope: scope
      }
    }).then(function (res) {
      if (res.data.scope === 'no_subscriber') {
        // sso successful but did not match any subscriber relationship
        reject(NO_SUBSCRIBER);
      } else if (res.data.scope === 'select_subscriber') {
        // sso successful but matched more than one subscriber
        reject({
          reason: SELECT_SUBSCRIBER,
          subscriber_list: res.data.subscribers
        });
      } else {
        // sso successful and a token was authored for a subscriber
        var tokenResult = processToken(res.data.token);

        if (tokenResult === true) {
          resolve(true);
        } else {
          reject(tokenResult);
        }
      }
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - ssoLogin err"), err);
      reject(err);
    });
  });
};
/**
 *
 * @param {string} username
 * @param {string} password
 * @param {string} idtoken
 * @param {string} vendor
 * @param {string} apiHash base64 encoding of client id and secret
 * @param {string|undefined} scope optional Application type Expects: 'netsapiens', 'webphone', 'video'
 * @return {Promise} Promise returns true, 'NO_SDK_CONFIG', 'LOGIN_FAIL', 'API_HASH_REQUIRED', 'INVALID_TOKEN'
 */


var ssoEnroll = function ssoEnroll(_ref3) {
  var username = _ref3.username,
      password = _ref3.password,
      idtoken = _ref3.idtoken,
      vendor = _ref3.vendor,
      apiHash = _ref3.apiHash,
      _ref3$scope = _ref3.scope,
      scope = _ref3$scope === void 0 ? 'netsapiens' : _ref3$scope;
  logger.info("".concat(MODULE_NAME, " - ssoEnroll called"), {
    username: username,
    password: password,
    idtoken: idtoken,
    vendor: vendor,
    apiHash: apiHash,
    scope: scope
  });
  return new Promise(function (resolve, reject) {
    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    if (!apiHash) {
      logger.error("".concat(MODULE_NAME, " - ssoEnroll apiHash prop missing"));
      console.error('ssoEnroll apiHash prop missing');
      reject(API_HASH_REQUIRED);
    }

    var _config$getConfigurat3 = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat3.apiURL;

    (0, _axios.default)({
      method: 'post',
      url: "".concat(apiURL, "oauth2/ssoEnroll"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: {
        username: username,
        password: password,
        idtoken: idtoken,
        vendor: vendor,
        scope: scope
      }
    }).then(function (res) {
      if (res.status && res.status < 400) {
        resolve(true);
      } else {
        reject(res);
      }
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - ssoEnroll err"), err);
      reject(err);
    });
  });
};
/**
 *
 * @param {string} username
 * @param {string} passcode
 * @param {string} mfa_type  Expects: 'authenticator'
 * @param {string} mfa_vendor  Expects: 'google'
 * @param {string|undefined} scope optional Application type Expects: 'netsapiens', 'webphone', 'video'
 *  Passing api_hash will attempt to login to the api directly
 * @param {string|undefined} authCode used for password recovery flow
 * @return {Promise} Promise returns true, 'NO_SDK_CONFIG', 'LOGIN_FAIL', 'API_HASH_REQUIRED', 'INVALID_TOKEN', 'MFA_REQUIRED'
 */


var mfaAuth = function mfaAuth(_ref4) {
  var username = _ref4.username,
      passcode = _ref4.passcode,
      mfa_type = _ref4.mfa_type,
      mfa_vendor = _ref4.mfa_vendor,
      apiHash = _ref4.apiHash,
      _ref4$scope = _ref4.scope,
      scope = _ref4$scope === void 0 ? 'netsapiens' : _ref4$scope;
  logger.info("".concat(MODULE_NAME, " - mfaAuth called"), {
    username: username,
    passcode: passcode,
    mfa_type: mfa_type,
    mfa_vendor: mfa_vendor,
    apiHash: apiHash,
    scope: scope
  });
  return new Promise(function (resolve, reject) {
    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    var grant_type = 'mfa';
    var ns_id_type = 'subscriber';
    var token = tokenUtil.get();

    var _config$getConfigurat4 = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat4.apiURL;

    (0, _axios.default)({
      method: 'post',
      withCredentials: true,
      url: "".concat(apiURL, "oauth2/netsapiensJs"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: {
        grant_type: grant_type,
        username: username,
        passcode: passcode,
        ns_id_type: ns_id_type,
        mfa_type: mfa_type,
        mfa_vendor: mfa_vendor,
        access_token: token
      }
    }).then(function (res) {
      var tokenResult = processToken(res.data.token);

      if (tokenResult === true) {
        resolve(true);
      } else {
        reject(tokenResult);
      }
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - mfaAuth err"), err);
      reject(err);
    });
  });
};
/**
 * revoke the token, log out the user
 * @param {string} apiHash base64 encoding of client id and secret
 * @return {Promise} Promise returns true, false, ERR
 */


var logout = function logout(apiHash) {
  logger.info("".concat(MODULE_NAME, " - logout called"), {
    apiHash: apiHash
  });
  return new Promise(function (resolve, reject) {
    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    if (!apiHash) {
      logger.error("".concat(MODULE_NAME, " - logout apiHash prop missing"));
      console.error('logout apiHash prop missing');
      reject(API_HASH_REQUIRED);
    }

    var existingToken = tokenUtil.get();

    var _config$getConfigurat5 = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat5.apiURL; // remove token


    tokenUtil.remove();
    (0, _axios.default)({
      method: 'post',
      withCredentials: true,
      url: "".concat(apiURL, "oauth2/revoke"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: {
        token: existingToken
      }
    }).then(function (res) {
      logger.debug("".concat(MODULE_NAME, " - logout success"), res);
      resolve(res);
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - logout err"), err);
      reject(err);
    });
  });
};
/**
 * Uses an existing token, if existing and valid
 * @returns {Promise} Promise returns true, 'INVALID_TOKEN', 'API_TOKEN_REFRESH_FAIL', 'NO_STORED_TOKEN'
 */


var proxyAuthentication = function proxyAuthentication(apiHash) {
  logger.info("".concat(MODULE_NAME, " - proxyAuthentication called"));
  return new Promise(function (resolve, reject) {
    logger.debug("".concat(MODULE_NAME, " - proxyAuthentication invoke tokenLogin"));

    if (!apiHash) {
      console.error('proxyAuthentication apiHash param missing');
      reject(API_HASH_REQUIRED);
    }

    tokenLogin(apiHash).then(function (res) {
      logger.debug("".concat(MODULE_NAME, " - proxyAuthentication tokenLogin res"), res);
      resolve(res);
    }).catch(function (err) {
      logger.debug("".concat(MODULE_NAME, " - proxyAuthentication tokenLogin err"), err);
      reject(err); // no user
    });
  });
};
/**
 * Video guest login
 * @param {string} guest
 * @param {string} confId
 * @param {string} apiHash base64 encoding of client id and secret
 * @param {string} scope optional Application type Expects: 'netsapiens', 'webphone', 'video'
 * @param guestEmail
 * @returns {Promise} Promise returns true, 'NO_SDK_CONFIG', 'API_HASH_REQUIRED', 'CONF_ID_REQUIRED'
 */


var videoGuestLogin = function videoGuestLogin(_ref5) {
  var apiHash = _ref5.apiHash,
      confId = _ref5.confId,
      guest = _ref5.guest,
      guestEmail = _ref5.guestEmail,
      _ref5$scope = _ref5.scope,
      scope = _ref5$scope === void 0 ? 'netsapiens' : _ref5$scope;
  logger.info("".concat(MODULE_NAME, " - guestLogin called"), {
    guest: guest,
    guestEmail: guestEmail,
    scope: scope,
    apiHash: apiHash
  });
  return new Promise(function (resolve, reject) {
    if (!_config.default.hasValidConfig()) {
      console.error('netsapiens sdk not configured');
      reject(_config.default.NO_SDK_CONFIG);
    }

    if (!apiHash) {
      console.error('videoGuestLogin apiHash param missing');
      reject(API_HASH_REQUIRED);
    }

    if (!confId) {
      console.error('videoGuestLogin confId param missing');
      reject(CONF_ID_REQUIRED);
    }

    var _config$getConfigurat6 = _config.default.getConfiguration(),
        apiURL = _config$getConfigurat6.apiURL;

    (0, _axios.default)({
      method: 'post',
      withCredentials: true,
      url: "".concat(apiURL, "oauth2/netsapiensJs"),
      headers: {
        Authorization: "Basic ".concat(apiHash)
      },
      data: {
        grant_type: 'guest',
        conf_id: confId,
        guest: guest,
        scope: scope,
        guestEmail: guestEmail
      }
    }).then(function (res) {
      if (res.status === 204) {
        reject(NO_CONF);
        return;
      }

      var tokenStr = res.data.token;
      logger.debug("".concat(MODULE_NAME, " - videoGuestLogin res"), tokenStr);

      if (!tokenStr) {
        logger.debug("".concat(MODULE_NAME, " - videoGuestLogin tokenStr null"), LOGIN_FAIL);
        reject(LOGIN_FAIL); // eslint-disable-next-line consistent-return

        return false;
      }

      if (!tokenUtil.isValid(tokenStr)) {
        logger.debug("".concat(MODULE_NAME, " - videoGuestLogin token.isValid reject"), INVALID_TOKEN);
        reject(INVALID_TOKEN); // eslint-disable-next-line consistent-return

        return false;
      }

      var decodedToken = tokenUtil.decode(tokenStr);
      logger.debug("".concat(MODULE_NAME, " - videoGuestLogin decodedToken"), decodedToken);
      tokenUtil.set(tokenStr);
      resolve(true);
    }).catch(function (err) {
      logger.error("".concat(MODULE_NAME, " - videoGuestLogin err"), err);
      reject(LOGIN_FAIL);
    });
  });
};

var _default = (_API_TOKEN_REFRESH_FA = {
  API_TOKEN_REFRESH_FAIL: API_TOKEN_REFRESH_FAIL,
  CONF_ID_REQUIRED: CONF_ID_REQUIRED,
  INVALID_TOKEN: INVALID_TOKEN,
  MFA_REQUIRED: MFA_REQUIRED,
  NO_CONF: NO_CONF
}, (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, _config.default.NO_SDK_CONFIG, _config.default.NO_SDK_CONFIG), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "NO_STORED_TOKEN", NO_STORED_TOKEN), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "authenticate", authenticate), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "ssoLogin", ssoLogin), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "ssoEnroll", ssoEnroll), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "mfaAuth", mfaAuth), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "proxyAuthentication", proxyAuthentication), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "videoGuestLogin", videoGuestLogin), (0, _defineProperty2.default)(_API_TOKEN_REFRESH_FA, "logout", logout), _API_TOKEN_REFRESH_FA);

exports.default = _default;
module.exports = exports.default;